var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMorthySmith({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_394",
    x: 0,
    y: 0,
    width: 73,
    height: 73,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29246",
    "data-name": "Group 29246",
    transform: "translate(583 10837)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -583, -10837)",
    filter: "url(#Ellipse_394)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_394-2",
    "data-name": "Ellipse 394",
    cx: 27.5,
    cy: 27.5,
    r: 27.5,
    transform: "translate(9 6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_50219",
    "data-name": "Path 50219",
    d: "M18.2,3A14.2,14.2,0,1,1,4,17.2c0-4.259,2.129-5.678,2.129-5.678C7.549,5.129,12.366,3,18.2,3Z",
    transform: "translate(-564.695 -10821.76)",
    fill: "#6d4c41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50220",
    "data-name": "Path 50220",
    d: "M28.777,28a3.194,3.194,0,1,0,3.194,3.194A3.194,3.194,0,0,0,28.777,28ZM8.194,28a3.194,3.194,0,1,0,3.194,3.194A3.194,3.194,0,0,0,8.194,28Z",
    transform: "translate(-564.986 -10829.016)",
    fill: "#ffd391"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50221",
    "data-name": "Path 50221",
    d: "M19.066,12A12.066,12.066,0,1,0,31.132,24.066,12.066,12.066,0,0,0,19.066,12Z",
    transform: "translate(-565.566 -10824.372)",
    fill: "#ffd391"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50222",
    "data-name": "Path 50222",
    d: "M25.632,39.722a3.126,3.126,0,0,0-5.586,0,.842.842,0,0,0,.806,1.117c.568,0,.852-.71,1.987-.71s1.42.71,1.987.71a.842.842,0,0,0,.806-1.117Z",
    transform: "translate(-569.339 -10831.918)",
    fill: "#bf360c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50223",
    "data-name": "Path 50223",
    d: "M24.156,34.156a1.405,1.405,0,0,1-2,0L21.09,33.092l2-2,1.065,1.065A1.4,1.4,0,0,1,24.156,34.156Z",
    transform: "translate(-569.655 -10829.912)",
    fill: "#fcf5ea"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_28955",
    "data-name": "Group 28955",
    transform: "translate(-556.437 -10805.274)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50224",
    "data-name": "Path 50224",
    d: "M25.615,22a4.259,4.259,0,1,0,4.259,4.259A4.259,4.259,0,0,0,25.615,22ZM14.259,22a4.259,4.259,0,1,0,4.259,4.259A4.259,4.259,0,0,0,14.259,22Z",
    transform: "translate(-10 -22)",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28956",
    "data-name": "Group 28956",
    transform: "translate(-552.888 -10801.016)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50225",
    "data-name": "Path 50225",
    d: "M27.066,28a.71.71,0,1,0,.71.71A.71.71,0,0,0,27.066,28ZM15.71,28a.71.71,0,1,0,.71.71A.71.71,0,0,0,15.71,28Z",
    transform: "translate(-15 -28)",
    fill: "#212121"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMorthySmith);
export default __webpack_public_path__ + "static/media/morthySmith.d67d4a0cb358fac770aef4340e862e7c.svg";
export { ForwardRef as ReactComponent };